const initCaptcha = (forms) => {
    forms.forEach((form) => {
        const captchaField = form.querySelector('.recaptcha_token');
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            grecaptcha.ready(() => {
                grecaptcha
                    .execute('6LeJ6PEsAAAAAKrMaQ8DNJDN0U5UQFbW7QTeBDJL', {
                        action: 'submit_custom_form',
                    })
                    .then((token) => {
                        captchaField.value = token;
                        form.submit();
                    });
            });
        });
    });
};

export default initCaptcha;
